export default (input: string): string => {
	const tempNode = document.createElement('div');
	tempNode.innerHTML = input;

	return tempNode.textContent || tempNode.innerText || '';
};
